import React from "react";
import InputAdornment from "@mui/material/InputAdornment";
import ErrorMessage from "../../buyflow/partials/error";
import FieldLabel from "../../../components/label";
import CallToAction from "../partials/cta";
import { styled } from "@mui/material/styles";
import { withStyles } from "@mui/styles";
import { Box, TextField, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";
import { SLUG_LOGIN, SLUG_OTP } from "../../../constants";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    paddingLeft: 0,
  },
  "& .MuiInputAdornment-root": {
    backgroundColor: "#ECF0F4", // theme.palette.divider,
    padding: "28px 14px",
    borderTopLeftRadius: theme.shape.borderRadius + "px",
    borderBottomLeftRadius: theme.shape.borderRadius + "px",
    fontSize: "1rem !important",
  },
  "& .MuiFormHelperText-root": {
    color: "#ff585d",
  },
}));

function AadhaarInputForm({
  classes: { containerButton, formGroup, mobileInput, mobileInputFocus },
  form,
  errorMessage,
  errors,
  handleChange,
  isFormSubmitted,
  onfocusMobile,
  onSubmit,
  toggleClass,
  validateInputLength,
}) {
  return (
    <form noValidate autoComplete="off" onSubmit={onSubmit}>
      <Box className={formGroup} pt={0}>
        <FieldLabel label={"Aadhaar Linked Mobile*"} />
        <CustomTextField
          id="standard-basic"
          variant="outlined"
          value={form.mobile}
          className={!onfocusMobile ? mobileInput : mobileInputFocus}
          name="mobile"
          onInput={validateInputLength}
          onChange={handleChange}
          onFocus={toggleClass}
          autoComplete="off"
          helperText={errorMessage.mobile}
          inputMode="numeric"
          fullWidth
          disabled={true}
          InputProps={{
            inputMode: "numeric",
            pattern: "[0-9]*",
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="subtitle1">+91</Typography>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box className={formGroup}>
        <FieldLabel label={"Aadhaar Number*"} />
        <TextField
          id="standard-basic"
          variant="outlined"
          value={form.aadhaar_number}
          name="aadhaar_number"
          onInput={validateInputLength}
          onChange={handleChange}
          autoComplete="off"
          helperText={errorMessage.aadhaar_number}
          inputMode="numeric"
          fullWidth
          disabled={isFormSubmitted || form.step === SLUG_OTP}
        />
      </Box>

      {form.step === SLUG_LOGIN && <ErrorMessage errors={errors} />}

      {form.step === SLUG_LOGIN && (
        <Box
          className={containerButton}
          justifyContent="center"
          alignContent="center"
        >
          <CallToAction
            buttonType={"submit"}
            errorMessage={errorMessage}
            form={form}
            isFormSubmitted={isFormSubmitted}
            text={"Generate OTP"}
            handleClick={() => {}}
            // marginTopClass={"marginTop10"}
            isDisabled={
              isFormSubmitted ||
              !form.mobile ||
              errorMessage.mobile ||
              !form.aadhaar_number ||
              errorMessage.aadhaar_number
            }
          />
        </Box>
      )}
    </form>
  );
}

export default withStyles(useStyles, { withTheme: true })(AadhaarInputForm);
